import StickyContact from "./StickyContact";
import React from "react";
import { IoIosArrowBack } from "react-icons/io";

interface ChoicesProps {
  state: any;
  update: (path: any) => void;
  handleNavigation: (key: any) => void;
}

export const Choices: React.FC<ChoicesProps> = ({
  state,
  update,
  handleNavigation,
}) => {
  let ListChoice = Object.keys(state.choices).sort();

  return (
    <div className=" flex flex-wrap mx-6% w-90%">
      <StickyContact />
      <div className="flex flex-wrap ">
        <div className="items-center flex mt-10%">
          <button onClick={() => update(-1)}>
            <IoIosArrowBack className="w-10 h-12" />
          </button>
          <div>
            <h1 className="text-2xl font-bold">{state.title}</h1>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 mt-5">
          {ListChoice.map((key: any) => {
            {
              console.log(state.choices[key].img);
            }
            return (
              <div className="relative" key={key}>
                <button onClick={() => handleNavigation(key)}>
                  {state.choices[key].img && (
                    <img
                      src={require(`../img/imgMateriau/${state.choices[key].img}`)}
                      alt=""
                      className="w-40 h-12 rounded text-white font-bold text-sm my-2 brightness-75"
                    />
                  )}
                  <h4 className="absolute top-45% left-1/2 -translate-x-1/2 -translate-y-1/2 font-medium text-sm text-white">
                    {state.choices[key].placeholder}
                  </h4>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
